import { fork } from 'redux-saga/effects';
import * as auth from './auth';
import * as mainList from './main-list';
import * as forms from './forms';


export default function* rootSaga() {

	yield fork(auth.handleLogin);

	yield fork(mainList.handleFetchMainList);
	yield fork(mainList.handleUpdateDate);

	yield fork(forms.handleSendForms);
}

export function getApiUrl(){
	return '/api/'
}



// WEBPACK FOOTER //
// ./src/sagas/index.js